//소켓 IO node서버 연결 주소
export const ENDPOINT = "http://localhost:4001";

//모션 인식 node 서버 연결 주소 (라즈베리파이 ip)
export const MOTION_POINT = "http://192.168.1.202:3001";
